import '../App.css';
import React from 'react';
import { connect } from 'react-redux';
import { language } from '../language';
import { Form, Button, Table, Modal, Alert } from 'react-bootstrap';
import { claimUpdateUser, claimGetUsers, claimCreateUser, claimDeleteUser } from '../Api';
import Header from '../Component/Header';


var timer

class ClaimUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allUser: [],
      addUserModalShow: false,

      createUserid: '',
      createUserUsername: '',
      createUserWinB1: '',
      createUserWinB2: '',
      createUserWinB3: '',
      createUserWinB4: '',
      createUserWinB5: '',
      createUserWinS1: '',
      createUserWinS2: '',
      createUserWinS3: '',
      createUserWinA1: '',
      createUserWinC: '',
      createUserWinA: '',

      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',
      UpdateDetails: false,

      OpenDeleteModal: false,
      ConfirmPassword: '',
      DetailsID: '',
    }
    this.handleClose = this.handleClose.bind(this)
  }

  async componentDidMount() {
    if (this.props.username === '') {
      this.props.history.push('/')
    } else {
      this.getAllUserListFunction();
    }
  }

  async getAllUserListFunction() {
    const allUser = await claimGetUsers(this.props.username, this.props.token)
    this.setState({ allUser: allUser.result })
  }

  handleClose() {
    this.setState({ 
      ConfirmPassword: '',
      OpenDeleteModal: false,
      addUserModalShow: false,
      UpdateDetails: false,
      createUserid: '',
      createUserUsername: '',
      createUserWinB1: '',
      createUserWinB2: '',
      createUserWinB3: '',
      createUserWinB4: '',
      createUserWinB5: '',
      createUserWinS1: '',
      createUserWinS2: '',
      createUserWinS3: '',
      createUserWinA1: '',
      createUserWinC: '',
      createUserWinA: '',
    })
  }

  async createUserF() {
    const createUserObject = {
      user: this.state.createUserUsername,
      winb1: this.state.createUserWinB1,
      winb2: this.state.createUserWinB2,
      winb3: this.state.createUserWinB3,
      winb4: this.state.createUserWinB4,
      winb5: this.state.createUserWinB5,
      wins1: this.state.createUserWinS1,
      wins2: this.state.createUserWinS2,
      wins3: this.state.createUserWinS3,
      wina1: this.state.createUserWinA1,
      winc: this.state.createUserWinC,
      wina: this.state.createUserWinA,
    }
    
    if (this.state.createUserUsername === '') {
      this.openNotification('Username不能放空', 'error')
    } else if (this.state.createUserWinB1 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB2 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB3 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB4 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB5 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinS1 === '') {
      this.openNotification('S1不能放空', 'error')
    } else if (this.state.createUserWinS2 === '') {
      this.openNotification('S1不能放空', 'error')
    } else if (this.state.createUserWinS3 === '') {
      this.openNotification('S1不能放空', 'error')
    } else if (this.state.createUserWinA1 === '') {
      this.openNotification('A1不能放空', 'error')
    } else if (this.state.createUserWinC === '') {
      this.openNotification('C不能放空', 'error')
    } else if (this.state.createUserWinA === '') {
      this.openNotification('A不能放空', 'error')
    } else {
      const createUserResult = await claimCreateUser(this.props.username, this.props.token, createUserObject)
      if (createUserResult.error === 'Duplicated Username, Please Choose Another'){
        this.openNotification('用户名重复，请另选', '')
      } else if (createUserResult.message && createUserResult.message === 'User Created Successful') {
        this.openNotification('增加成功', '')
        this.handleClose()
        this.getAllUserListFunction();
      }
      
    }
  }

  openNotification(message, type) {
    this.setState({ notificationMessage: message, notificationType: type }, () => {
      this.setState({ showNotification: true });
    });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({
        showNotification: false,
        notificationMessage: ''
      });
    }, 5000);
  };

  async DeleteUsers(details) {
    this.setState({OpenDeleteModal: true, DetailsID: details.id})
  }

  async ConfirmDelete() {
    const ConfirmPassword = this.state.ConfirmPassword
    if (ConfirmPassword === '') {
      this.openNotification('Wrong Password','error')
    } else {
      const deleteUserResult = await claimDeleteUser(this.props.username, this.state.DetailsID, ConfirmPassword, this.props.token)
      if (deleteUserResult.message === 'Wrong Password') {
        this.openNotification('删除失败, 密码错误', 'error')
      } else {
        if (deleteUserResult.message === 'User Deleted Successful') {
          this.openNotification('删除成功', '')
          this.handleClose()
          this.getAllUserListFunction();
        } else {
          this.openNotification('删除失败', 'error')
        }
      }
    }
  }

  ChangeUserDetails(details) {
    this.setState({
      createUserid: details.id,
      createUserUsername: details.user,
      createUserWinB1: details.winb1,
      createUserWinB2: details.winb2,
      createUserWinB3: details.winb3,
      createUserWinB4: details.winb4,
      createUserWinB5: details.winb5,
      createUserWinS1: details.wins1,
      createUserWinS2: details.wins2,
      createUserWinS3: details.wins3,
      createUserWinA1: details.wina1,
      createUserWinC: details.winc,
      createUserWinA: details.wina,
      addUserModalShow: true, 
      UpdateDetails: true, 
    })
  }

  async UpdateUsersDetails() {
    const Passobject = {
      id: this.state.createUserid,
      user: this.state.createUserUsername,
      winb1: this.state.createUserWinB1,
      winb2: this.state.createUserWinB2,
      winb3: this.state.createUserWinB3,
      winb4: this.state.createUserWinB4,
      winb5: this.state.createUserWinB5,
      wins1: this.state.createUserWinS1,
      wins2: this.state.createUserWinS2,
      wins3: this.state.createUserWinS3,
      wina1: this.state.createUserWinA1,
      winc: this.state.createUserWinC,
      wina: this.state.createUserWinA,
    }
    if(this.state.createUserUsername === '') {
      this.openNotification(`${language[this.props.currentLanguage].UsernameError}`, 'error')
    } else if (this.state.createUserWinB1 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB2 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB3 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB4 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinB5 === '') {
      this.openNotification('B1不能放空', 'error')
    } else if (this.state.createUserWinS1 === '') {
      this.openNotification('S1不能放空', 'error')
    } else if (this.state.createUserWinS2 === '') {
      this.openNotification('S1不能放空', 'error')
    } else if (this.state.createUserWinS3 === '') {
      this.openNotification('S1不能放空', 'error')
    } else if (this.state.createUserWinA1 === '') {
      this.openNotification('A1不能放空', 'error')
    } else if (this.state.createUserWinC === '') {
      this.openNotification('C不能放空', 'error')
    } else if (this.state.createUserWinA === '') {
      this.openNotification('A不能放空', 'error')
    } else {
      const updateUserResult = await claimUpdateUser(this.props.username, this.props.token, Passobject)
      if (updateUserResult.message && updateUserResult.message === 'User Updated Successful') {
        this.openNotification('更新成功', '')
        this.handleClose()
        this.getAllUserListFunction();
      } else {
        this.openNotification('更新失败', 'error')
      }
    }
  }

  enterUpdateUsersDetails(e) {
    if (e.key === 'Enter') {
      this.UpdateUsersDetails()
    }
  }

  render() {
    return (
      <div fluid style={{ fontFamily: 'cursive', backgroundImage: 'linear-gradient(#D0F0F5, #E7EDFF, #F0E8FF)', minHeight: '100vh' }}>
        <Header style={{ position: 'absolute', top: 0}}/>
        <Alert className='AlertPage' style={{ zIndex: 99, position: 'fixed', right: 0, top: 80 }}show={this.state.showNotification} variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
          <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
        </Alert>
        <Modal centered show={this.state.addUserModalShow} onHide={this.handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {(this.state.UpdateDetails === true) ? `${language[this.props.currentLanguage].EditUserDetails}` :`${language[this.props.currentLanguage].AddUser}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.UpdateDetails && <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
              <div style={{ width: 100 }}>ID</div>
              <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserid} onChange={(e) => this.setState({ createUserUsername: e.target.value })} disabled/>
            </div>}

            <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
              <div style={{ width: 100 }}>{language[this.props.currentLanguage].Username}</div>
              <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserUsername} onChange={(e) => this.setState({ createUserUsername: e.target.value })} />
            </div>
            <div style={{ display: 'flex', marginBottom: 10, alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ width: 100 }}>B</div>
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinB1} onChange={(e) => this.setState({ createUserWinB1: e.target.value })} />
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinB2} onChange={(e) => this.setState({ createUserWinB2: e.target.value })} />
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinB3} onChange={(e) => this.setState({ createUserWinB3: e.target.value })} />
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinB4} onChange={(e) => this.setState({ createUserWinB4: e.target.value })} />
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinB5} onChange={(e) => this.setState({ createUserWinB5: e.target.value })} />
              </div>
              <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ width: 100 }}>S</div>
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinS1} onChange={(e) => this.setState({ createUserWinS1: e.target.value })} />
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinS2} onChange={(e) => this.setState({ createUserWinS2: e.target.value })} />
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinS3} onChange={(e) => this.setState({ createUserWinS3: e.target.value })} />
              </div>
              <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ width: 100 }}>A1</div>
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinA1} onChange={(e) => this.setState({ createUserWinA1: e.target.value })} />
              </div>
              <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ width: 100 }}>C</div>
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinC} onChange={(e) => this.setState({ createUserWinC: e.target.value })} />
              </div>
              <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center', flexDirection: 'column' }}>
                <div style={{ width: 100 }}>A</div>
                <Form.Control onKeyDown={(e) => this.enterUpdateUsersDetails(e)} style={{ width: 150}} value={this.state.createUserWinA} onChange={(e) => this.setState({ createUserWinA: e.target.value })} />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => this.handleClose()}>{language[this.props.currentLanguage].Close}</Button>
            {this.state.UpdateDetails === true ?
              <Button variant="success" onClick={() => this.UpdateUsersDetails()}>提交</Button>
              : 
              <Button variant="success" onClick={() => this.createUserF()}>提交</Button>
            }
          </Modal.Footer>
        </Modal>
        <Modal centered show={this.state.OpenDeleteModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirm Delete
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
              <div style={{ width: 100 }}>Username</div>
              <Form.Control style={{ width: 150}} value={this.props.username} disabled={true}/>
            </div>
            <div style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
              <div style={{ width: 100 }}>确认密码</div>
              <Form.Control style={{ width: 150}} value={this.state.ConfirmPassword} onChange={(e) => this.setState({ ConfirmPassword: e.target.value })} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => this.handleClose()}>关闭</Button>
            <Button variant="danger" onClick={() => this.ConfirmDelete()}>确定删除</Button>
          </Modal.Footer>
        </Modal>
        <div className='UserListView'>
          <div className='UserListInsideView'>
            <h2 className='TitleSize'>卜字赔率</h2>
          </div>
          <div style={{ display: 'flex' }}>
            <div className='UserListButton'>
              <button className="buttonAdd" onClick={() => this.setState({ addUserModalShow: true })}>增加</button>
            </div>
          </div>
        </div>
        <div className="tableFixed">
          <Table striped bordered hover responsive style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }} className='userList'>
            <thead className='userList'>
              <tr>
                <th style={{ minWidth: '100px' }}>ID</th>
                <th style={{ minWidth: '100px' }}>名</th>
                <th style={{ minWidth: '100px' }}>B</th>
                <th style={{ minWidth: '100px' }}>S</th>
                <th style={{ minWidth: '100px' }}>A1</th>
                <th style={{ minWidth: '100px' }}>C</th>
                <th style={{ minWidth: '100px' }}>A</th>
                <th style={{ minWidth: '100px' }}>行动</th>
              </tr>
            </thead>
            <tbody className='userList'>
              {this.state.allUser.map((item, index) => 
                (item.Role !== 'Zu') && <tr key={index}>
                  <td>{item.id}</td>
                  <td>{item.user}</td>
                  <td><div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div>{item.winb1}</div>
                    <div>{item.winb2}</div>
                    <div>{item.winb3}</div>
                    <div>{item.winb4}</div>
                    <div>{item.winb5}</div>
                  </div></td>
                  <td><div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div>{item.wins1}</div>
                    <div>{item.wins2}</div>
                    <div>{item.wins3}</div>
                  </div></td>
                  <td>{item.wina1}</td>
                  <td>{item.winc}</td>
                  <td>{item.wina}</td>
                  <td style={{ display: 'flex' }}>
                    <div style={{ marginRight: 5 }}>
                      <button className="button2" onClick={() => this.ChangeUserDetails(item)}>换资料</button>
                    </div>
                    <div style={{ marginRight: 5 }}>
                      <button className="buttonDelete" onClick={() => this.DeleteUsers(item)}>删除户口</button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.currentLanguage,
    username: state.username,
    token: state.token,
    role: state.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimUser);
